import { toLower } from "lodash"
import PropTypes from "prop-types"
import UnifiedSearch from "modules/unified-search"
import { RECENT_INSTRUMENT_SEARCH_TYPES } from "resources/instruments"
import { SECURITY_IDS } from "./shapes"

function SecuritiesSearch({ account, modelId, itemsActions, disableSearchResult, securitySelected, assetId, assetType, startDate, endDate, intraday, isExpanded, securityIds }) {
  const emptySearch = <div className="add-universe-securities-label">
    { assetId ? `Search securities in this ${toLower(assetType)}` : "Search securities, baskets, or ETFs"}
  </div>

  return <div className="add-universe-securities-search">
    <UnifiedSearch
      disablePortal
      autoFocus
      multiSelect
      {...{
        account,
        modelId,
        itemsActions,
        emptyContent: emptySearch,
        disableResult: disableSearchResult,
        searchType: RECENT_INSTRUMENT_SEARCH_TYPES.FILTER,
        resultSelected: securitySelected,
        hiddenTypes: ["researchTopics", "currencies"],
        compositeAssetId: assetId,
        compositeAssetType: assetType,
        startDate,
        endDate,
        intraday,
        isExpanded,
        securityIds,
      }}
    />
  </div>
}

SecuritiesSearch.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  itemsActions: PropTypes.object.isRequired,
  disableSearchResult: PropTypes.func.isRequired,
  securitySelected: PropTypes.func,
  portfolioId: PropTypes.string,
  assetId: PropTypes.string,
  assetType: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  intraday: PropTypes.bool,
  isExpanded: PropTypes.bool,
  securityIds: SECURITY_IDS,
}

export default SecuritiesSearch
